import { useDispatch, useSelector } from "react-redux";
import RoleService from "../services/RoleService"
import { setDropdownOptions } from "../store/slices/role/roleSlice";
import { RootState } from "../store/store";

export const useRole = () => {
    const dispatch = useDispatch();
    const { dropdownOptions } = useSelector((state: RootState) => state.roles);

    const fetchRoles = async () => {
        try {
            const result = await RoleService.fetchRolesForSelect();
            dispatch(setDropdownOptions(result.data));
        } catch (error) {
            if (error.response) {
                const status = error.response.status;

                // Manejo de errores según el código de estado
                if (status === 401) {
                    console.error("No autorizado: La sesión ha expirado o las credenciales son incorrectas.");
                    alert("Tu sesión ha expirado. Inicia sesión nuevamente.");
                } else if (status === 404) {
                    console.error("No se encontraron roles disponibles.");
                    alert("No se encontraron roles disponibles.");
                } else if (status >= 500) {
                    console.error("Error del servidor: Inténtalo más tarde.");
                    alert("Hubo un error en el servidor. Inténtalo más tarde.");
                } else {
                    console.error(`Error desconocido: ${error.message}`);
                    alert("Ocurrió un error inesperado. Inténtalo de nuevo.");
                }
            } else {
                console.error("Error de conexión con el servidor.");
                alert("No se pudo conectar con el servidor. Verifica tu conexión a internet.");
            }
        }
    }

    const fetchRolesDropdown =  async () => {
        try {
            const response = await RoleService.getDropdown();
            dispatch(setDropdownOptions(response));
        } catch (error) {
            console.error("Error al cargar el dropdown:", error);
        }
    }

    return {
        fetchRoles,
        dropdownOptions,
        fetchRolesDropdown,
    }
}